import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import Card from '../../components/core/Card';

/**
 * A generic Card component which supports flipping back and forth between content.
 */
export default class FlipCard extends React.PureComponent {
  static propTypes = {
    /**
     * Callback when the flip button (cog icon) is clicked.
     */
    onFlipClick: PropTypes.func,
    /**
     * Content to render when card is flipped.
     */
    flipContent: PropTypes.node,
    /**
     * Width of card.
     */
    width: PropTypes.string,
    /**
     * Height of card.
     */
    height: PropTypes.string,
    /**
     * Additional style properties to apply.
     */
    className: PropTypes.string,
    /**
     * Id for automation testing.
     */
    testid: PropTypes.string,
  };

  static defaultProps = {
    onFlipClick: R.identity,
    flipContent: null,
    width: '225px',
    height: '175px',
    className: '',
    testid: 'flip-card',
  };

  constructor(props) {
    super(props);
    this.state = {
      flipped: false,
    };
  }

  _onFlipClick = (e) => {
    this.props.onFlipClick(e);
    this.setState({ flipped: !this.state.flipped });
  };

  render() {
    const { className, width, height, children, flipContent, testid } = this.props;
    const { flipped } = this.state;
    const cardProps = {
      width,
      height,
      testid,
      className: `flip-card ${className}`,
    };
    const settingsBar = (
      <div className="card-top-bar">
        <div className="settings-holder" onClick={this._onFlipClick}>
          <i className="material-icons h_fz-body2">{flipped ? 'clear' : 'settings'}</i>
        </div>
      </div>
    );
    return (
      <Card {...cardProps}>
        <div className="flip-card-container">
          {flipContent ? settingsBar : null}
          <div className="content">{flipped ? flipContent : children}</div>
        </div>
      </Card>
    );
  }
}
